function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Instruktora-atv\\u0113rums",
  transform: "translate(-303.000000, -26.000000)",
  fill: "#262626",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Top-Bar",
  transform: "translate(270.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Button",
  transform: "translate(24.000000, 15.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.7071068,11.2928932 C15.0675907,11.6533772 15.0953203,12.2206082 14.7902954,12.6128994 L14.7071068,12.7071068 L12.414,15 L22,15 C22.5522847,15 23,15.4477153 23,16 C23,16.5128358 22.6139598,16.9355072 22.1166211,16.9932723 L22,17 L12.414,17 L14.7071068,19.2928932 C15.0675907,19.6533772 15.0953203,20.2206082 14.7902954,20.6128994 L14.7071068,20.7071068 C14.3466228,21.0675907 13.7793918,21.0953203 13.3871006,20.7902954 L13.2928932,20.7071068 L9.29289322,16.7071068 C9.25749917,16.6717127 9.22531295,16.6343256 9.19633458,16.5953066 L9.12467117,16.4840621 L9.12467117,16.4840621 L9.07122549,16.371336 L9.07122549,16.371336 L9.03584514,16.265993 L9.03584514,16.265993 L9.0110178,16.1484669 L9.0110178,16.1484669 L9.00397748,16.0898018 L9.00397748,16.0898018 L9,16 L9.00278786,15.9247615 L9.00278786,15.9247615 L9.02024007,15.7992742 L9.02024007,15.7992742 L9.04973809,15.6878575 L9.04973809,15.6878575 L9.09367336,15.5767785 L9.09367336,15.5767785 L9.14599545,15.4792912 L9.14599545,15.4792912 L9.20970461,15.3871006 L9.20970461,15.3871006 L9.29289322,15.2928932 L9.29289322,15.2928932 L13.2928932,11.2928932 C13.6834175,10.9023689 14.3165825,10.9023689 14.7071068,11.2928932 Z",
  id: "ic-goback"
})))));

function SvgIcGoback(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "10px",
    viewBox: "0 0 14 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C35866A9-1135-4A8C-B973-FB194B591B22") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGoback);
export default __webpack_public_path__ + "static/media/ic-goback.545addbc.svg";
export { ForwardRef as ReactComponent };